import {
	usePetitionDetailsPageData,
	usePetitionDetailsPageFcm,
	usePetitionDetailsPageUserData,
} from 'src/app/pages/petitionGamma/details/pageContext';

export function usePromoteCtaDisplayed(): boolean {
	const {
		data: {
			petition: { promotable },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { ownPetition },
	} = usePetitionDetailsPageUserData();
	const { promotionCtaEnabled } = usePetitionDetailsPageFcm();

	return promotable && !ownPetition && promotionCtaEnabled;
}
